const is = {
  common: {
    loading: 'Hleð...',
  },
  nav: {
    home: 'Heim',
    dictation: 'Diktering',
    rtc: 'Rauntímatextun',
  },
  transcript: {
    export: {
      formatChoose: 'Veldu skrársnið',
      formatTitleTxt: 'TXT',
      formatTitleSrt: 'SRT',
      formatTitleSmartSrt: 'Smart_SRT (beta)',
      formatTitleAudacity: 'Audacity',
      formatTitleWebVtt: 'WebVTT (paint-on)',
      formatDescriptionTxt: 'Skrársnið sem inniheldur einugis textann.',
      formatDescriptionSrt:
        'Skráarsnið sem inniheldur textann ásamt tímastimplum fyrir hverja línu eins og þeir birtast í ritlinum. SRT er gjarnan notað þegar texta skal myndefni.',
      formatDescriptionSmartSrt:
        'Skráarssnið sem inniheldur textann ásamt tímastimplum fyrir hverja línu. Línuskil eru valin þannig að þau fylgi sem best íslenskum viðmiðum um textun fyrir sjónvarp. SRT er gjarnan notað þegar texta skal myndefni. Þessi eiginleiki er enn á tilraunastigi og kemur því fyrir að hann virki því ekki alltaf eins og til er ætlað. Þessi eiginleiki kann að taka smástund fyrir lengri upptökur.',
      formatDescriptionAudacity: 'Skráarsnið sem virkar með hljóðvinnsluforritinu Audacity.',
      formatDescriptionWebVtt:
        'Web Video Text Tracks eða WebVTT er skráarsnið sem inniheldur textann ásamt tímastimplum fyrir hverja línu eins og þeir birtast í ritlinum ásamt auka upplýsingum.',
      downloadError: 'Villa kom upp við að sækja skrá.',
      downloadErrorContact:
        'Ef ekkert virðist ganga, heyrðu þá í okkur á <a href="mailto:tiro@tiro.is">tiro@tiro.is</a> :)',
      downloadErrorMessageSmartSrtA: 'Vúpsí! SmartSRT er almennt frekar smart en greinilega ekki í dag.',
      downloadErrorMessageSmartSrtB: 'Eigum við að reyna aftur?',
      downloadErrorMessageSmartSrtC: 'Prófaðu að ganga úr skugga um að allir bútar endi á stöku bili.',
      downloadErrorMessageSmartSrtD: 'Skortur á bilum hefur stundum verið að stríða SmartSRT.',
      downloadErrorMessageDefault: 'Óþekkt villa kom upp við niðurhal.',
    },
  },
};

export default is;
